import { useUnit } from "effector-react"
import financeSettingsStore from "stores/financeSettings"

export default function useFinanceSettings() {
    return useUnit(financeSettingsStore.$financeSettings)
}
